// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"mS-z","inlineTitle":"nS-z","sponsoredAdsWrapper":"oS-z","marketplaceRecosWrapper":"pS-z"};